/* eslint-disable prefer-const */
import React, { KeyboardEvent, useState } from 'react';
import styled from 'styled-components';
import Dropdown from './Dropdown';
import SearchInput from './SearchInput';
import Option from './Option';
import SearchWithDropdownContext from './SearchWithDropdownContext';

const SearchWithDropdownWrapper = styled.div`
  display: flex;
`;

type ValueType = {
  options: string[];
  inputValue: string[] | string;
};

type Props = {
  onChange: (value: ValueType) => void;
  onEnterClick?: (e: KeyboardEvent) => void;
  className?: string;
  children?: any;
  placeholder?: string;
  defaultValue?: ValueType;
  value?: {
    options: [];
    inputValue: string;
  };
  ['aria-label']?: string;
  ['data-qa-id']?: string;
};

const SearchWithDropdown = ({
  children,
  onChange,
  onEnterClick,
  className,
  placeholder,
  defaultValue = {
    options: [],
    inputValue: '',
  },
  value,
  'aria-label': ariaLabel,
  'data-qa-id': qaId,
}: Props) => {
  let [inputValue, setInputValue] = useState(defaultValue.inputValue);
  const [allOptions, setAllOptions] = useState([]);
  let [selectedOptions, setSelectedOptions] = useState(defaultValue.options);

  if (value) {
    // eslint-disable-next-line
    inputValue = value.inputValue;
    selectedOptions = value.options;
  }

  return (
    <SearchWithDropdownContext.Provider
      value={{
        allOptions,
        setAllOptions,
        selectedOptions,
        setSelectedOptions,
        inputValue,
        setInputValue,
        onChange,
        onEnterClick,
      }}
    >
      <SearchWithDropdownWrapper className={className} data-qa-id={`${qaId}-search-with-dropdown`}>
        <Dropdown>{children}</Dropdown>
        <SearchInput placeholder={placeholder} aria-label={ariaLabel} />
      </SearchWithDropdownWrapper>
    </SearchWithDropdownContext.Provider>
  );
};

SearchWithDropdown.Option = Option;

export default SearchWithDropdown;
